import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type AlertsAction = ActionType<typeof actions>;

export interface Alert {
  id: number;
  title: string;
  description: string;
  createdAt: string;
}

export enum AlertsActionTypes {
  LIST_FETCH_REQUEST = "@Alerts/LIST_FETCH_REQUEST",
  LIST_FETCH_SUCCESS = "@Alerts/LIST_FETCH_SUCCESS",
  LIST_FETCH_ERROR = "@Alerts/LIST_FETCH_ERROR",

  UNREAD_LIST_FETCH_REQUEST = "@Alerts/UNREAD_LIST_FETCH_REQUEST",
  UNREAD_LIST_FETCH_SUCCESS = "@Alerts/UNREAD_LIST_FETCH_SUCCESS",
  UNREAD_LIST_FETCH_ERROR = "@Alerts/UNREAD_FETCH_LIST_ERROR",

  READ_ALERT_REQUEST = "@Alerts/READ_ALERT_REQUEST",
  READ_ALERT_SUCCESS = "@Alerts/READ_ALERT_SUCCESS",
  READ_ALERT_ERROR = "@Alerts/READ_ALERT_ERROR",
}

export interface AlertsState {
  readonly count: number;
  readonly alerts: Alert[];
  readonly isLoading: boolean;
  readonly unreadAlerts: Alert[];
}
